import React from 'react'

function PopupConfirm({text, id, textBtnConfirm, onClickConfirm, textBtnCancel, onClickCancel}) {
  return (
    <div className='PopupConfirm' id={id}>
        <div className="popup-content">
            <h2>{text}</h2>
            <div className="btn-container">
                <button className='supprimer' onClick={onClickConfirm}>{textBtnConfirm}</button>
                <button className='annuler' onClick={onClickCancel}>{textBtnCancel}</button>
            </div>
        </div>
    </div>
  )
}

export default PopupConfirm;